import { render, staticRenderFns } from "./QrLanding.vue?vue&type=template&id=4fdd3214&scoped=true&"
import script from "./QrLanding.vue?vue&type=script&lang=js&"
export * from "./QrLanding.vue?vue&type=script&lang=js&"
import style0 from "./QrLanding.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QrLanding.vue?vue&type=style&index=1&id=4fdd3214&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd3214",
  null
  
)

/* custom blocks */
import block0 from "./QrLanding.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./QrLanding.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCard,VCardText,VCarousel,VCarouselItem,VCol,VContainer,VDialog,VRow})
